/**
 * jQuery Cookie plugin
 *
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie = function (key, value, options) {

    // key and at least value given, set cookie...
    if (arguments.length > 1 && String(value) !== "[object Object]") {
        options = jQuery.extend({}, options);

        if (value === null || value === undefined) {
            options.expires = -1;
        }

        if(!key) {
            return;
        }

        if (typeof options.expires === 'number') {
            var days = options.expires, t = options.expires = new Date();
            t.setDate(t.getDate() + days);
        }

        value = String(value);
        /*if(options.domain) {
            options.domain = options.domain.replace("m.kinorium",".kinorium");
            options.domain = options.domain.replace("m.ru.",".");
            options.domain = options.domain.replace("m.ua.",".");
            options.domain = options.domain.replace("ru.",".");
            options.domain = options.domain.replace("ua.",".");
        }*/

        if(options.subdomain) {
            options.domain = options.subdomain;
        }
        if(options.ssubdomain) {
            options.domain = options.ssubdomain;
        }

        if(key != 'syncCookie') {
            var setCookie = $.cookie('syncCookie') ? JSON.parse($.cookie('syncCookie')) : [];
            var newCookie = jQuery.extend({}, options);
            newCookie.key = key;
            newCookie.value = value;
            setCookie.push(newCookie);

            if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && days > 7) {
                $.cookie('syncCookie',JSON.stringify(setCookie),{path:'/'});
            }
        }

        var cookieA = [
            encodeURIComponent(key), '=',
            options.raw ? value : encodeURIComponent(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
        ];
        return (document.cookie = cookieA.join(''));
    }

    // key and possibly options given, get cookie...
    options = value || {};
    var result, decode = options.raw ? function (s) { return s; } : decodeURIComponent;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null;
};
